import { render, staticRenderFns } from "./urunBilgisi.vue?vue&type=template&id=69832cc0&"
import script from "./urunBilgisi.vue?vue&type=script&lang=js&"
export * from "./urunBilgisi.vue?vue&type=script&lang=js&"
import style0 from "./urunBilgisi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports